import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderComponent } from './slider/slider.component';
import { RouterModule } from '@angular/router';
import { ProductHolderComponent } from './product-holder/product-holder.component';
import { ExclusiveBannersComponent } from './exclusive-banners/exclusive-banners.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { LoaderComponent } from './loader/loader.component';


@NgModule({
  declarations: [SliderComponent, ProductHolderComponent, ExclusiveBannersComponent, TestimonialsComponent, LoaderComponent],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    SlickCarouselModule
  ],
  exports:[SliderComponent,
     ProductHolderComponent,
      ExclusiveBannersComponent,
      TestimonialsComponent,
      LoaderComponent]
})
export class SharedModule { }
